import React from "react";

/**
 * Container für den Arbeitsbereich (ohne obere Navigation und untere Buttonbar) in der Betriebsakte.
 * @returns {JSX.Element}
 * @constructor
 */
export default function EABetriebsakteDatenContainer(props) {
    return <div id={"betriebsakteDatenContainer"} {...props} />;
}
